import React, { useEffect, useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import api from "../../../services/api";
import SheetCard from "./SheetCard";

export default function SheetsModal({ show, onClose, orderPositionId }) {
  const [sheetsData, setSheetsData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show || !orderPositionId) return;

    const fetchSheets = async () => {
      setLoading(true);
      try {
        const res = await api.get(`/orders/linked-sheets/${orderPositionId}`);
        setSheetsData(res.data);
      } catch (err) {
        console.error("Ошибка загрузки листов", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSheets();
  }, [show, orderPositionId]);

  return (
    <Modal 
      show={show} 
      onHide={onClose} 
      size="xl"
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>Листы для печати</Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        ) : !sheetsData || sheetsData.elements?.length === 0 ? (
          <div className="text-center text-muted py-4">
            Листы не найдены
          </div>
        ) : (
          <div>
            <div className="mb-3">
              Всего листов: <strong>{sheetsData.totalCount}</strong>
            </div>
            
            {sheetsData.elements.map((sheet) => (
              <SheetCard key={sheet.id} sheet={sheet} />
            ))}
          </div>
        )}
      </Modal.Body>
      
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Закрыть
        </Button>
      </Modal.Footer>
    </Modal>
  );
}